import { Action, configureStore, ThunkAction } from '@reduxjs/toolkit';
import { api } from './api/api';
import dataUploadSlice from './dataUpload/dataUploadSlice';
import userSlice from './user/userSlice';

const middlewares = [api.middleware];

export const store = configureStore({
  reducer: {
    [api.reducerPath]: api.reducer,
    [userSlice.name]: userSlice.reducer,
    [dataUploadSlice.name]: dataUploadSlice.reducer,
  },
  // it's SUPER important to add middleware for any API slices otherwise caching and updates will not work
  middleware: getDefaultMiddleware => getDefaultMiddleware().concat(middlewares),
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, RootState, unknown, Action<string>>;
